var heading = {
    // Normal heading "# Hello"
    normal: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n|$)/,

    // 2 Lines heading
    line: /^([^\n]+)\n *(=|-){2,} *(?:\n|$)/,

    // ID in heading
    id: /({#)(.+)(})/g
};

module.exports = heading;



//////////////////
// WEBPACK FOOTER
// ../~/markup-it/syntaxes/markdown/re/heading.js
// module id = 319
// module chunks = 0